import { render, staticRenderFns } from "./item_content.vue?vue&type=template&id=62df9d16&scoped=true"
import script from "./item_content.vue?vue&type=script&lang=js"
export * from "./item_content.vue?vue&type=script&lang=js"
import style0 from "./item_content.vue?vue&type=style&index=0&id=62df9d16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62df9d16",
  null
  
)

export default component.exports